<script setup>
/* Imports */
import { inject } from 'vue';
import { sendAnalyticsEvent, sanitizeAnalyticsString } from '@garmin/analytics';

/* Helpers */
import {
  mapGetters,
} from '../helpers/mainHelpers.js';

/* Inject */
const translations = inject('translations');

const {
  getCustomerGroups: customerGroups,
  getListPriceUnformatted: listPrice,
  getSalePriceUnformatted: salePrice,
  getHasDiscount: hasDiscount,
} = mapGetters();

/* Props */
const props = defineProps({
  map: {
    type: Object,
    default: () => ({}),
  },
  index: {
    type: Number,
    required: true,
  },
});

/* Map SKU buy URL */
const mapSkuBuyUrl = props.map?.skuBuyUrl;

const sendAnaliticsClickEvent = () => {
  const analyticsData = {
    tealium_event: 'select_item',
    employee_flag: customerGroups?.value === 'US' ? 'true' : 'false',
    index: props.index + 1,
    is_sale: hasDiscount.value(props.map?.sku) ? 'yes' : 'no',
    item_family: 'NA',
    item_list_id: 'marine_maps_sidebar',
    item_list_name: 'Marine Maps Sidebar',
    product_name: sanitizeAnalyticsString(props.map?.name) || 'NA',
    price_shown: (listPrice.value(props.map?.sku) || salePrice.value(props.map?.sku)) ? 'yes' : 'no',
    product_price: salePrice.value(props.map?.sku) || listPrice.value(props.map?.sku) || 'NA',
    product_id: props.map?.buyUrl?.split('/p/')[1]?.split('/')[0] || 'NA',
    product_url: props.map?.buyUrl || 'NA',
  };
  sendAnalyticsEvent(analyticsData);
};
</script>

<template>
  <div class="shop-now-product-card-btn">
    <template v-if="mapSkuBuyUrl">
      <g-button
        :href="mapSkuBuyUrl"
        class="shop-now-product-card-btn__shop-now-button"
        size="medium"
        data-testid="shop-now-button"
        @click="sendAnaliticsClickEvent"
      >
        {{ translations.ITFE_MARINE_MAPS_RESULT_BUTTON_TEXT }}
      </g-button>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.shop-now-product-card-btn {
  display: flex;
  margin-top: auto; // Ensures button is pushed to bottom on card on mobile
  cursor: auto;

  @include breakpoint('sm') {
    justify-content: flex-end;
    margin-top: 0;
  }

  &__shop-now-button {
    margin: 0;

    :deep(.g__button) {
      width: 100%;
      @include breakpoint('sm') {
        width: auto;
      }
    }
  }

  :deep(.g__button__host) {
    width: 100%;

    @include breakpoint('sm') {
      width: auto;
    }
  }
}
</style>
